<template>
    <div :style="outStyle">
        <el-select :disabled="disabled" :value="value" :size="size" clearable :placeholder="placeholder" :multiple="multiple" @change="changeOperator" :style="'width:' + width ">
            <el-option
                v-for="v in optionArr"
                :key="v.code"
                :label="v.name"
                :value="v.code">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        name: 'KeySelect',
        props: {
            value: String,
            optionArr:Array,
            placeholder:String,
            outStyle: {
                type: Object,
                default: ()=>({
                    display: 'inline-block',
                    marginRight: '6px'
                })
            },
            width:{
                type:String,
                default:"140px"
            },
            size:{
                type:String,
                default:"small"
            },
            multiple:{
                type:Boolean,
                default:false
            },
            disabled: {
                type:Boolean,
                default: false
            }
        },
        methods:{
            changeOperator(val){
                this.$emit('input',val);
                this.$emit('changeSelect',val);
            },
        }
    }
</script>

